import React from 'react'
import App from './App'

export default function DirectorsAccountShow({ appProps, screenClass, account, accountsPath, title, description, labels }) {
  function formatDate(value) {
    if (!value) return '-'

    return new Date(value).toLocaleString()
  }

  function renderEmail(email) {
    return (
      <div key={ email.id } className='director-pill director-show-email'>
        <div className='director-pill-line'>
          <span>{ email.email || '-' }</span>
          { email.searchPath && (
            <a href={ email.searchPath } className='director-icon-link' title={ labels.viewEmail }>
              <i className='fa-light fa-eye'></i>
            </a>
          ) }
        </div>
        { email.primary && <strong>{ labels.primary }</strong> }
        { email.unconfirmed && <strong>{ labels.unconfirmed }</strong> }
      </div>
    )
  }

  function renderTenant(tenant) {
    return (
      <div key={ tenant.id } className='director-tenant-row'>
        <div>
          <strong>{ tenant.flavor || '-' }</strong>
          <span>{ tenant.tenantUid }</span>
        </div>
        <div className='director-role'>
          { tenant.role }
          { tenant.platform && <span>{ tenant.platform }</span> }
        </div>
      </div>
    )
  }

  return (
    <App appProps={ appProps }>
      <div className={ screenClass }>
        <div className='director-shell'>
          <section className='director-header'>
            <div>
              <span>{ labels.eyebrow }</span>
              <h1>{ title }</h1>
              <p>{ description }</p>
            </div>
            <a href={ accountsPath } className='button inverted director-back-link'>
              <i className='fa-light fa-arrow-left'></i>
              { labels.backToAccounts }
            </a>
          </section>

          <section className='director-email-account'>
            <div className='director-email-account-header'>
              <div>
                <strong>{ account.fullName || account.uid }</strong>
                <span>{ labels.uid } { account.uid }</span>
              </div>
              <div className='director-account-badges'>
                { account.superadmin && <em>{ labels.superadmin }</em> }
                { account.confirmed && <em>{ labels.confirmed }</em> }
              </div>
            </div>

            <div className='director-show-meta'>
              <span>{ labels.created } { formatDate(account.createdAt) }</span>
              <span>{ labels.lastSignIn } { formatDate(account.lastSignInAt) }</span>
            </div>

            <div className='director-email-account-grid'>
              <div>
                <div className='director-section-label'>{ labels.emails }</div>
                <div className='director-email-list'>
                  { account.emails.length ? account.emails.map(renderEmail) : <span className='director-empty'>{ labels.noEmails }</span> }
                </div>
              </div>

              <div>
                <div className='director-section-label'>{ labels.flavorsAndRoles }</div>
                <div className='director-tenant-list'>
                  { account.tenants.length ? account.tenants.map(renderTenant) : <span className='director-empty'>{ labels.noFlavors }</span> }
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </App>
  )
}
